import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@apollo/react-hooks';
import { Container, Row, Col, InputGroup, Form } from 'react-bootstrap';

import * as S from './styles';
import { history } from '@src/history';

import { Loading, BreadCrumb } from '@atoms';
import { NoResult } from '@molecules';

import { FAQ_CATEGORIES } from '@components/pages/FaqPage/queries';
import { faqCategories } from '@components/pages/FaqPage/__generated__/faqCategories';
import { faqSearchUrl, faqUrl } from '@src/app/routes';

const FaqPage = () => {
  const { data, loading } = useQuery<faqCategories>(FAQ_CATEGORIES, {
    variables: {
      first: 99,
      name: '',
    },
  });

  const [query, setQuery] = useState('');

  const handleClick = (e: any) => {
    history.push(`${faqSearchUrl}?q=${query}`);
  };

  const breadCrumbData = [
    {
      name: 'FAQ',
    },
  ];

  if (loading) {
    return <Loading />;
  }

  return data?.faqCategories?.edges?.length > 0 ? (
    <Container>
      <BreadCrumb data={breadCrumbData} />
      <Row>
        <Col>
          <InputGroup>
            <Form.Control
              className="input-group-prepend"
              name="query"
              type="text"
              placeholder="Search FAQs"
              value={query}
              onChange={(e: any) => {
                setQuery(e.target.value);
              }}
            />
            <button className="btn btn-primary" onClick={handleClick}>
              Search
            </button>
          </InputGroup>
        </Col>
      </Row>
      <br />
      <S.FaqTitle>FAQ Categories</S.FaqTitle>
      <Row>
        {data.faqCategories.edges.map((category, idx) => {
          return (
            <Col key={idx} xs={12} md={6}>
              <div className="d-grid gap-2">
                <Link to={`${faqUrl}${category.node.id}/`}>
                  <S.FaqButton>
                    <span>{category.node.name}</span>
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-arrow-right"
                        viewBox="0 0 16 16"
                      >
                        <path d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z" />
                      </svg>
                    </span>
                  </S.FaqButton>
                </Link>
              </div>
            </Col>
          );
        })}
      </Row>
    </Container>
  ) : (
    <NoResult />
  );
};

export { FaqPage };
